<template>
  <div class="retrievePassword">
    <div class="head">
      <!-- <p>武汉乐联</p> -->
      <p @click="cancel">登录</p>
    </div>
    <div class="main">
      <div class="w">
        <el-steps :active="0" align-center>
          <el-step title="找回密码"></el-step>
          <el-step title="重置登录密码"></el-step>
          <el-step title="重置成功"></el-step>
        </el-steps>
        <div class="dis">
          <el-form
            ref="loginFormRef"
            :model="loginForm"
            :rules="loginFormRules"
            label-width="0px"
            class="login_form"
          >
            <!-- 用户名 -->
            <el-form-item prop="company_mobile">
              <el-input
                v-model="loginForm.company_mobile"
                placeholder="请输入您账号绑定的手机号/邮箱"
                onkeyup="this.value=this.value.replace(/\s+/g,'')"
              ></el-input>
            </el-form-item>

            <el-form-item prop="code">
              <el-input
                v-model="loginForm.code"
                placeholder="验证码"
                class="formInput"
              ></el-input>
              <div class="block_code_dome cursor">
                <el-button :disabled="disabled" @click="verificationCode">{{
                  computeTime == 0 ? "获取验证码" : computeTime + "秒后获取"
                }}</el-button>
              </div>
            </el-form-item>
            <!-- 按钮区域 -->
            <el-form-item class="btns">
              <el-button class="size" type="primary" @click="next"
                >下一步</el-button
              >
              <el-button plain class="size" @click="cancel">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { postData } from "../api/index";
export default {
  data() {
    // 设置手机号的验证规则
    const phoneRules = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号/邮箱"));
      } else {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
        const reg2 = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (reg.test(value)) {
          callback();
        } else if (reg2.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号/邮箱"));
        }
      }
    };
    return {
      loginForm: {
        company_mobile: "",
        code: "",
      },
      //禁用按钮
      disabled: false,
      // 防抖节流
      computeTime: 0,

      //获取验证码
      timerId: "",
      // 这是表单的验证规则对象
      loginFormRules: {
        // 手机号验证规则
        company_mobile: [{ validator: phoneRules, trigger: "blur" }],
        // 验证码是否合法
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { min: 4, max: 4, message: "长度为4个字符", trigger: "blur" },
        ],
        id: "",
      },
    };
  },
  mounted() {},
  methods: {
    // 获取验证码
    verificationCode() {
      let subname = { subname: this.loginForm.company_mobile };
      postData("/common/ForgotPswAction", subname).then((res) => {
        if (res.code == 200) {
          this.id = res.data.id;
          this.disabled = true;
          if (this.computeTime == 0) {
            this.computeTime = 60;
            this.timerId = setInterval(() => {
              this.computeTime--;
              if (this.computeTime == 0) {
                this.disabled = false;
                clearInterval(this.timerId);
              }
            }, 1000);
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 下一步
    next() {
      // console.log(this.loginForm);
      postData("/common/ValidPswAction", {
        subname: this.loginForm.company_mobile,
        code: this.loginForm.code,
      }).then((res) => {
        if (res.code == 200) {
          this.$router.push({
            name: "resetPasswords",
            query: {
              id: this.id,
              company_mobile: this.loginForm.company_mobile,
            },
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 取消
    cancel() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.retrievePassword {
  .head {
    width: 100%;
    height: 56px;
    background-color: #f8f9fb;
    display: flex;
    justify-content: space-around;
    align-items: center;
    box-shadow: 0 1px 1px 1px #e2e5ec;
    p:nth-of-type(1) {
      font-size: 24px;
      color: #409eff;
      font-weight: bold;
    }
    p:nth-of-type(2) {
      color: #333333;
      cursor: pointer;
    }
  }
  .main {
    width: 100%;
    margin-top: 53px;
    .w {
      width: 1707px;
      margin: 0 auto;
      .el-steps--horizontal {
        margin-top: 147px;
      }
      /deep/.el-step.is-horizontal .el-step__line {
        top: 18px;
        background-color: #f4f4f4;
      }
      /deep/.el-step__icon {
        width: 38px;
        height: 38px;
        font-size: 18px;
      }
      /deep/.el-step__head.is-process {
        color: #409eff;
        border: #409eff;
      }
      /deep/.el-step__title.is-process {
        font-weight: 400;
        color: #409eff;
      }
      .dis {
        display: flex;
        justify-content: center;
        margin-top: 81px;
        .login_form {
          width: 448px;
          background-color: #fff;
          box-sizing: border-box;
          position: relative;
          .right_top {
            position: absolute;
            right: 0;
            top: 0;
            .zxdl {
              position: absolute;
              top: 18px;
              right: 50px;
              width: 70px;
              line-height: 22px;
              font-size: 14px;
              text-align: center;
              border: 1px solid #409eff;
              background-color: #e9eefa;
              color: #409eff;
              span {
                position: absolute;
                right: -5px;
                top: 6px;
                width: 8px;
                height: 8px;
                background-color: #e9eefa;
                transform: rotate(45deg);
                border-top: 1px solid #409eff;
                border-right: 1px solid #409eff;
              }
            }
          }
          .btns {
            .size {
              width: 180px;
            }
            .size:nth-of-type(1) {
              margin-right: 88px;
            }
            .el-button + .el-button {
              margin-left: 0;
            }
          }
        }
      }
      .formInput {
        width: 72%;
        margin-right: 13px;
      }
      .block_code_dome {
        display: inline-block;
        width: 25%;
        img {
          width: 100%;
        }
      }
      .cursor {
        cursor: pointer;
      }
      .block_img_change_ref {
        background: rgb(65, 45, 45);
      }
    }
  }
}
</style>
